var _path, _path2;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgEmail(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 25,
    viewBox: "0 0 24 25",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M17 22.1436H7C3.35 22.1436 1.25 20.0436 1.25 16.3936V9.39355C1.25 5.74355 3.35 3.64355 7 3.64355H17C20.65 3.64355 22.75 5.74355 22.75 9.39355V16.3936C22.75 20.0436 20.65 22.1436 17 22.1436ZM7 5.14355C4.14 5.14355 2.75 6.53355 2.75 9.39355V16.3936C2.75 19.2536 4.14 20.6436 7 20.6436H17C19.86 20.6436 21.25 19.2536 21.25 16.3936V9.39355C21.25 6.53355 19.86 5.14355 17 5.14355H7Z",
    fill: "white"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M11.9998 13.7635C11.1598 13.7635 10.3098 13.5035 9.65978 12.9735L6.52978 10.4735C6.20978 10.2135 6.14978 9.74352 6.40978 9.42352C6.66978 9.10352 7.13978 9.04353 7.45978 9.30353L10.5898 11.8035C11.3498 12.4135 12.6398 12.4135 13.3998 11.8035L16.5298 9.30353C16.8498 9.04353 17.3298 9.09352 17.5798 9.42352C17.8398 9.74352 17.7898 10.2235 17.4598 10.4735L14.3298 12.9735C13.6898 13.5035 12.8398 13.7635 11.9998 13.7635Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmail);
export default __webpack_public_path__ + "static/media/email.375497923f46457f9bf3dd16b90304f2.svg";
export { ForwardRef as ReactComponent };